import { useState } from 'react';

import { Button } from '@/components/core/Button';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogHeaderDefault,
} from '@/components/core/Dialog';
import { ReceivedReviews } from '@/components/item-review/ReceivedReviews.tsx';
import { useTranslation } from '@/hooks/useTranslation';

interface ItemReviewsDialogProps {
    primaryKey: string;
    publicationDestination?: string;
    reviewer?: string;
    onClose: () => void;
}

const ItemReviewsDialog = ({
    primaryKey,
    publicationDestination,
    reviewer,
    onClose,
}: ItemReviewsDialogProps) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(true);

    return (
        <Dialog
            open={open}
            onOpenChange={(next) => {
                setOpen(next);
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent variant="screen" data-testid="item-reviews-dialog">
                <DialogHeader>
                    <DialogHeaderDefault closeLabel={t('CLOSE')}>
                        {t('REVIEW.REVIEW_FOR_ITEM')} {primaryKey}
                    </DialogHeaderDefault>
                </DialogHeader>
                <DialogBody scrollable={true}>
                    <ReceivedReviews
                        primaryKey={primaryKey}
                        publicationDestination={publicationDestination}
                        reviewer={reviewer}
                    />
                </DialogBody>
                <DialogFooter>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" type="button">
                            {t('CLOSE')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { ItemReviewsDialog, type ItemReviewsDialogProps };
